import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

let cache = null;
let inflight = null;
const subs = new Set();

function fetchFlags() {
  if (!inflight) {
    inflight = axios
      .get(`${API}/public/feature-flags`)
      .then((r) => r.data || {})
      .catch(() => ({}))
      .then((f) => {
        cache = f;
        subs.forEach((s) => s(f));
        return f;
      });
  }
  return inflight;
}

export function useFeatureFlags() {
  const [flags, setFlags] = useState(cache);
  useEffect(() => {
    const cb = (f) => setFlags(f);
    subs.add(cb);
    if (cache) setFlags(cache);
    else fetchFlags();
    return () => subs.delete(cb);
  }, []);
  return flags;
}

export function updateFeatureFlagsCache(next) {
  cache = { ...(cache || {}), ...next };
  subs.forEach((s) => s(cache));
}
